import Model from 'flarum/common/Model';
import app from 'flarum/common/app';
export default class Dialog extends Model {
  title() {
    return Model.attribute('title').call(this);
  }
  type() {
    return Model.attribute('type').call(this);
  }
  lastMessageAt() {
    return Model.attribute('lastMessageAt', Model.transformDate).call(this);
  }
  createdAt() {
    return Model.attribute('createdAt', Model.transformDate).call(this);
  }
  users() {
    return Model.hasMany('users').call(this);
  }
  firstMessage() {
    return Model.hasOne('firstMessage').call(this);
  }
  lastMessage() {
    return Model.hasOne('lastMessage').call(this);
  }

  /**
   * The id of this dialog's first or last message, when it has one.
   *
   * A dialog can be left without either, for instance when the message one of
   * them pointed at was deleted, so every caller has to cope with the
   * relationship being absent rather than reading straight through it.
   */
  messageRelationshipId(name) {
    return this.data.relationships?.[name]?.data?.id;
  }
  unreadCount() {
    return Model.attribute('unreadCount').call(this);
  }
  lastMessageId() {
    return Model.attribute('lastMessageId').call(this);
  }
  lastReadMessageId() {
    return Model.attribute('lastReadMessageId').call(this);
  }
  lastReadAt() {
    return Model.attribute('lastReadAt', Model.transformDate).call(this);
  }

  /** Everyone in it can reply: someone allowed to message users without messaging permission has. */
  anyoneCanReply() {
    return Model.attribute('anyoneCanReply').call(this);
  }
  canSendMessage() {
    return Model.attribute('canSendMessage').call(this);
  }
  recipient() {
    let users = this.users();
    return !users ? null : users.find(user => user && user.id() !== app.session.user.id());
  }
}
flarum.reg.add('flarum-messages', 'common/models/Dialog', Dialog);